// Quote class includes the backtick: if a minifier/Rolldown change ever emits a
// template-literal import() specifier, a `['"]`-only class would silently fail to
// extract the path and disable retries app-wide. The \1 backreference still pairs the quote.
const URI_OR_RELATIVE_PATH_REGEX = /([`'"])((\w+:(\/?\/?))?[^\s,]+)\1/;

export function extractModulePathFromImporter(importer: () => any): string | null {
  const fnString = importer.toString();
  const match = fnString.match(URI_OR_RELATIVE_PATH_REGEX);
  if (!match) return null;
  return match.filter(Boolean)[2];
}